import { Directive, ElementRef, HostListener, AfterViewInit, Renderer2, Input } from '@angular/core';

@Directive({
    selector: '[parent-nav]',
})
export class ParentNavDirective implements AfterViewInit {
    ul;
    @Input() mobile: boolean = false;

    constructor(private el: ElementRef,
        private renderer: Renderer2) {
    }

    ngAfterViewInit(): void {
        this.ul = this.el.nativeElement.querySelector('ul');
    }

    @HostListener('mouseenter') onMouseEnter() {
        if (!this.mobile) {
            this.renderer.addClass(this.ul, 'active');
        }
    }

    @HostListener('mouseleave') onMouseLeave() {
        if (!this.mobile) {
            this.renderer.removeClass(this.ul, 'active');
        }
    }

    @HostListener('click') onClick($event) {
        if (this.mobile) {
            if (!this.ul.classList.contains('mb-child-nav-active')) {
                this.renderer.addClass(this.ul, 'mb-child-nav-active');
            } else {
                this.renderer.removeClass(this.ul, 'mb-child-nav-active');
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/directives/parentnav.directive.ts